<template>
  <input-with-units
    name="memory"
    class="memory-input"
    :available-units="availableUnits"
    :value="value"
    @input="onInput"
    :placeholder="placeholder"
    :label="label"
    :disabled="disabled"
    :size="size"
    :errors="errors"
  />
</template>

<script>
import InputWithUnits from '@/mixins/InputWithUnits';

export default {
  name: 'memory-input',
  mixins: [InputWithUnits(['B', 'KB', 'MB', 'GB', 'TB'])],
};
</script>



// WEBPACK FOOTER //
// MemoryInput.vue?3df1e8ff